import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditInfoTextProps } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { formatSelectedDays } from 'src/components/oneCorp/features/MealCredit/utils/formatSelectedDays';

export function getDaysOfWeekText(
  props: Pick<
    MealCreditInfoTextProps,
    | 'selectedDays'
    | 'isRepeating'
    | 'budgetResetType'
    | 'budgetResetPeriod'
    | 'isMonthAvailable'
    | 'monthAvailableOn'
  >
): string {
  const {
    selectedDays,
    isRepeating,
    budgetResetType,
    budgetResetPeriod,
    isMonthAvailable,
    monthAvailableOn,
  } = props;
  const formattedDays = formatSelectedDays({ selectedDays });
  const connectingTextDays = isRepeating ? ' every' : '';
  const connectingTextWeekOrMonth =
    isRepeating ||
    // when budgetResetType has value, it means that CUSTOM was chosen from the dropdown budgetLength
    (budgetResetType === BudgetResetTypeValues.WEEKS && budgetResetPeriod > 7)
      ? 'each'
      : 'the';
  const weekOrMonth =
    isMonthAvailable && monthAvailableOn !== MonthAvailability.WITHIN_DATE_RANGE
      ? 'month'
      : 'week';

  return formattedDays
    ? `${connectingTextDays} ${formattedDays}`
    : ` every day of ${connectingTextWeekOrMonth} ${weekOrMonth}`;
}
